import dayjs from 'dayjs'
import type { Dayjs } from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat.js'

dayjs.extend(customParseFormat)

/** Returns the first strict parse that succeeds, or an invalid Dayjs (`isValid()` is false). */
export const parseTimeWithFormats = (value: string, formats: readonly string[]): Dayjs => {
  const normalized = value.trim()
  for (const format of formats) {
    const parsed = dayjs(normalized, format, true)
    if (parsed.isValid()) return parsed
  }
  return dayjs(Number.NaN)
}
